import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import withErrorHandler from '../../hoc/with-error-handler';
import axios from '../../shared/axios';

import { apiOptions } from '../../shared/constants';
import * as sharedActions from '../../shared/store/actions';

import { RootState } from '../../store';

import pieceOfCakeSound from '../../assets/sounds/piece-of-cake-611.mp3';
import { UnreadMessageUser } from '../../shared/models';
import { AppDispatch } from '../../store';
let isPlayAudioBusy = false;

export type UnreadMessageComponentProps = {
  currentUserId: string;
  agencyId: string;
  userType: string;
};

const UnreadMessageComponent = ({ currentUserId, agencyId, userType }: UnreadMessageComponentProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const didMount = useRef(false);

  const { unreadMessage } = useSelector((state: RootState) => state.webSocket);

  const playAudio = (audio: HTMLAudioElement) => {
    if (!isPlayAudioBusy) {
      audio.play();
      audio.onended = () => (isPlayAudioBusy = false);
    }
  };

  useEffect(() => {
    if (!didMount.current) {
      dispatch(
        sharedActions.sendMessage({
          isUnreadMessage: true,
          currentUserId: currentUserId,
          agencyId: agencyId,
          userType: userType,
        } as UnreadMessageUser),
      );

      didMount.current = true;
    }
  }, []);

  useEffect(() => {
    if (unreadMessage && unreadMessage.isUnreadMessage === true) {
      const element = document.querySelector('#showNewSmsLabel') as HTMLSpanElement;

      if (element) {
        element.style.display = unreadMessage.hasUnreadMessage === true ? 'block' : 'none';

        if (
          unreadMessage.withoutSound === false &&
          unreadMessage.hasUnreadMessage === true &&
          localStorage.getItem('reactTabKey')?.toString() === (window as any).reactTabKey.toString()
        ) {
          playAudio(new Audio(`${apiOptions.appAssetsRootPath}${pieceOfCakeSound}`));
        }
      }
    }
  }, [unreadMessage]);

  return <React.Fragment> </React.Fragment>;
};

export default withErrorHandler(UnreadMessageComponent, axios);
